import React, { useState } from 'react'
import { ResetPasswordContainer } from '@/components/containers/reset-password'
import { RouteComponentProps } from 'react-router-dom'

export const ResetPasswordPage: React.FC<RouteComponentProps> = () => {
  return <ResetPasswordContainer />
}
